"use client";

import { useState } from "react";

export default function SubscribeBox() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [msg, setMsg] = useState<{ type: "ok" | "err"; text: string } | null>(
    null
  );
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMsg(null);

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, consent }),
      });

      const data = await res.json();
      setLoading(false);

      if (data.ok) {
        setEmail("");
        setConsent(false);
        setMsg({
          type: "ok",
          text:
            "Subscribed! Check your inbox for a welcome email from Flightpath Mentoring.",
        });
        if (data.warn) console.warn(data.warn);
      } else {
        setMsg({
          type: "err",
          text: data.error || "Something went wrong. Please try again.",
        });
      }
    } catch (err: any) {
      console.error(err);
      setLoading(false);
      setMsg({ type: "err", text: "Network error. Please try again." });
    }
  }

  return (
    <section className="bg-neutral-950 border border-neutral-800 rounded-2xl p-6 mt-16 not-prose">
      <h3 className="text-lg font-semibold text-white">
        Get new insights by email
      </h3>
      <p className="text-neutral-400 mt-1">
        Short, practical reflections from the flight deck — no spam, just value.
      </p>

      <form
        onSubmit={onSubmit}
        className="mt-4 flex flex-col sm:flex-row gap-3 w-full"
      >
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="you@example.com"
          className="flex-1 bg-black border border-neutral-700 rounded-xl px-4 py-2 text-white placeholder-neutral-500"
        />

        <button
          type="submit"
          disabled={loading}
          className="border border-amber-400 rounded-xl px-4 py-2 text-amber-400 hover:bg-amber-400 hover:text-black transition disabled:opacity-50"
        >
          {loading ? "Subscribing..." : "Subscribe"}
        </button>
      </form>

      <label className="flex items-start gap-2 mt-3 text-xs text-neutral-400">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-0.5 accent-amber-400"
          required
        />
        I consent to receive occasional emails about new insights. I can
        unsubscribe at any time.
      </label>

      {msg && (
        <p
          className={`mt-3 text-sm ${
            msg.type === "ok" ? "text-green-400" : "text-red-400"
          }`}
        >
          {msg.text}
        </p>
      )}
    </section>
  );
}
